module.exports = __webpack_public_path__ + "static/media/tuto-3.10b2d9da.jpg";